import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { Extension } from './base/Extension';
import classes from '../styles.module.css';

export class Placeholder extends Extension {
  constructor(private readonly placeholder: string) {
    super('placeholder');
  }

  plugins() {
    return [
      new Plugin({
        props: {
          decorations: (state) => {
            const { doc } = state;
            const decorations: Decoration[] = [];
            const completelyEmpty =
              doc.childCount <= 1 && doc.content.size <= 2 && doc.textContent === '';

            if (completelyEmpty) {
              doc.descendants((node, pos) => {
                if (pos !== 0 || node.type.name !== 'paragraph') {
                  return;
                }

                const decoration = Decoration.node(pos, pos + node.nodeSize, {
                  class: classes.placeholder,
                  'data-empty-text': this.placeholder,
                });
                decorations.push(decoration);
              });
            }

            return DecorationSet.create(doc, decorations);
          },
        },
      }),
    ];
  }
}
